export const environment = {
  production: false,
  apiUrl: "https://api-migestor-dev.megatecs.org/api",
};
